import BrokenImage from '@mui/icons-material/BrokenImage'
import { Avatar, ListItemText } from '@mui/material'
import { useEffect, useState } from 'react'
import { mediaURL } from 'src/consumer/services'
import {
  APCategoryCountAvatarContainer,
  APCategoryCountContainer,
  APCategoryCountListItem,
} from '../ActivityPlanPageStyles'

export default function APCategoryCountComponent({ countMap = {}, setupData }) {
  const [categoryCount, setCategoryCount] = useState([])

  useEffect(() => {
    if (Object.keys(countMap)?.length > 0) {
      const categoryCount = []
      Object.keys(countMap)?.forEach((key) => {
        categoryCount.push({
          categoryId: key,
          count: countMap[key],
        })
      })
      setCategoryCount(categoryCount)
    }
  }, [countMap])
  return (
    <APCategoryCountContainer dense>
      {categoryCount
        ?.sort((catCount1, catCount2) => catCount2.count - catCount1.count)
        ?.map((catCount, idx) => (
          <APCategoryCountListItem key={idx}>
            <APCategoryCountAvatarContainer>
              <Avatar
                sizes="small"
                sx={{ width: 30, height: 30 }}
                src={`${mediaURL}${
                  setupData?.metaCategories?.find((mCat) => mCat?.id === catCount?.categoryId)
                    ?.iconId ||
                  setupData?.metaCategories?.find((mCat) => mCat?.id === catCount?.categoryId)
                    ?.coverIcon
                }`}
              >
                <BrokenImage sx={{ fontSize: '18px' }} />
              </Avatar>
            </APCategoryCountAvatarContainer>
            <ListItemText
              primary={
                setupData?.metaCategories?.find((mCat) => mCat?.id === catCount?.categoryId)?.[
                  catCount?.count > 1 ? 'title' : 'singleTitle'
                ] ||
                setupData?.metaCategories?.find((mCat) => mCat?.id === catCount?.categoryId)?.title
              }
            />
          </APCategoryCountListItem>
        ))}
    </APCategoryCountContainer>
  )
}
